import { mapCommonFile } from './CommonFile.mappers';
export const mapShape = (file, baseFile) => {
  var _file$media, _file$media2;
  const width = (_file$media = file.media) == null || (_file$media = _file$media.vector) == null || (_file$media = _file$media.image) == null ? void 0 : _file$media.width;
  const height = (_file$media2 = file.media) == null || (_file$media2 = _file$media2.vector) == null || (_file$media2 = _file$media2.image) == null ? void 0 : _file$media2.height;
  return {
    ...mapCommonFile(file, baseFile),
    mediaType: 'shape',
    width: typeof width === 'number' ? width : null,
    height: typeof height === 'number' ? height : null
  };
};
//# sourceMappingURL=Shape.mappers.js.map